// react
import React, { useEffect, useContext} from 'react';
import useForm from 'react-hook-form';
import moment from "moment";
import ReactTable from "react-table";
import CsvDownloader from 'react-csv-downloader';
import { useTranslation } from 'react-i18next';
import Datetime from "react-datetime";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from '@material-ui/core/TextField';
import Select from 'react-select';
import {ValidSelect} from "beaktShared/helpers/validselect";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";

// services
import { MaskDate, formateDate, convertDate, validateDate, transformValueFloattoFormated, getLocale, getStringFormatDate } from "beaktShared/helpers/masks";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';
const useStyles = makeStyles(styles);

export default function RelatorioCreditosDebitos() {
    const { t } = useTranslation();

    const session = useContext(SessionContext);
    const { register, setValue, errors, setError, clearError, getValues } = useForm({mode: "onBlur"});
   
    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };
    
    const [dtini, setdtini] = React.useState(formateDate(moment(new Date()).add(-1, 'months')));
    const [dtfim, setdtfim] = React.useState(formateDate(moment(new Date())));
    useEffect(() => {        
        verifyAcess();
    }, []);

    const verifyAcess = () =>{
        if(session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
        {
            setshowestabelecimento(true);
            LoadEstabelecimentos();
        }
        else //Acessando tela pelo modulo Clinica   
        {
            setestabelecimento({estabelecimentoId:session.estabelecimentoId});
            setValue("estabelecimento", {estabelecimentoId:session.estabelecimentoId});
            setshowestabelecimento(false)
        }
    }          

    const [tipo, settipo] = React.useState("Todos");
    const optionsTipo = [
        { value: 'Todos', label: 'Todos' },
        { value: 'C', label: 'Crédito' },
        { value: 'D', label: 'Débito' }
    ]
    const handleTipoChange = (value) => {
        settipo(value);
    }

    const [showestabelecimento, setshowestabelecimento] = React.useState(false);
    const [isLoadingEstabelecimento, setisLoadingEstabelecimento] = React.useState(false);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const [estabelecimento, setestabelecimento] = React.useState(0);
    const LoadEstabelecimentos = () =>{
        setisLoadingEstabelecimento(true);
        const endPoint = "estabelecimentos/ativos/byfranquia/"+session.franquiaId;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'error')
                setisLoadingEstabelecimento(false);
                return false;
            }

            setisLoadingEstabelecimento(false);
            setestabelecimentos(result.data);
            return true;
        });  
    }
    const handleEstabelecimentoChange = event => {
        let value = event
        
        setestabelecimento(value);
        setValue("estabelecimento", value);
        if (value !== "")
            clearError(t('label.establishment'));
    }

    const monthDiff = (dateFrom, dateTo) => {
        return dateTo.getMonth() - dateFrom.getMonth() + 
        (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
    }
    
    const handleClickPesquisa = () =>{
        let data = getValues();
        
        if (estabelecimento === "" || estabelecimento === 0)
            return setError(t('label.establishment'), "required")
        else
            clearError(t('label.establishment'))

        if(data.dtini === "")
        {
            setError("dtini","required", t('label.required'))
            return false;
        }
        else
            clearError("dtini")
        
        if(data.dtfim === "")
        {
            setError("dtfim","required", t('label.required'))
            return false;
        }
        else
            clearError("dtfim")
        
        if (!validateDate(data.dtini)) {
            setError("dtini", "invaliddate", t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dtini")
        
        if (!validateDate(data.dtfim)) {
            setError("dtfim", "invaliddate", t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dtfim")
        
        var dataIniConvertida = convertDate(data.dtini);
        var dataFimConvertida = convertDate(data.dtfim);
        
        if(monthDiff(dataIniConvertida,dataFimConvertida) > 12){            
            showNotification(t('error_message.select_12month'), 'danger')
            return false; 
        }        

        let obj = {
            estabelecimentoId: estabelecimento,
            dataIni:dataIniConvertida,
            dataFim:dataFimConvertida,
            tipo:tipo
        }
        loadDados(obj);
    };

    const [isLoadingList, setisLoadingList] = React.useState(false);
    const [list, setlist] = React.useState([]);
    const loadDados = (obj) =>{ 
        setisLoadingList(true);       
        const endPoint = "relatorios/relcreditosdebitos/";
        UsePostApi(endPoint,obj).then(result=>{    
            if(result.status !== 200)
            {   
                showNotification(result.message, 'danger')
                setisLoadingList(false);
                return false; 
            }
            
            setlist(result.data);
            loadDataCsv(result.data);
            setisLoadingList(false);
            return true;                
        });  
    }

    const columnsProp = [{
        Header: t('label.establishment'),
        filterable: false,
        accessor: "estabelecimento.descricao",
    },
    {
        Header: t('label.month')+" / "+t('label.year'),
        filterable: false,
        accessor: "mesAno"
    },
    {
        Header: t('royaltie.closing'),
        accessor: "royaltieId",
        Cell: (props)=> <span>  {props.value ? t('label.yes') : t('label.not')} </span>,
        filterable: false
    },
    {
        Header: t('sale.type'),
        filterable: false,
        accessor: "tipo"
    },
    {
        Header: t('label.description'),
        filterable: false,
        accessor: "historico"
    },
    {
        Header: t('label.value'),
        filterable: false,
        accessor: "valor",
        Cell: (props) => <div> {transformValueFloattoFormated(props.value?props.value:0)} </div>
    }]
    const columns = [...columnsProp]

    const [dataCSV,setdataCSV] = React.useState([]);  
    const columnsCSV = [
        {id: 'estabelecimento', displayName: 'Estabelecimento'}, 
        {id: 'mesAno', displayName: 'Mês Ano'}, 
        {id: 'royaltieId', displayName: 'Royaltie'}, 
        {id: 'tipo', displayName: 'Tipo'}, 
        {id: 'historico', displayName: 'Historico'}, 
        {id: 'valor', displayName: 'Valor'}
    ];
    const loadDataCsv = (data) =>{
        let dtCsv = [];

        data.map(item =>{
            var obj = {
                estabelecimento: item.estabelecimento.descricao,
                mesAno: item.mesAno,
                royaltieId: item.royaltieId,
                tipo: item.tipo,
                historico: item.historico.trimEnd(),
                valor: item.valor
            };
            dtCsv.push(obj);
        })

        setdataCSV(dtCsv);
    } 

    const classes = useStyles();
    return (
    <div>
        <GridContainer>
            <GridItem xs={12}>
                <Card>
                    <CardHeader color="primary" icon>
                        <CardIcon color="primary">
                            <Assignment />
                        </CardIcon>
                        <h4 className={classes.cardIconTitle}>{t('reports.credit_and_debt_report')} </h4>
                    </CardHeader>
                    <CardBody>
                    <GridContainer>
                        {showestabelecimento &&
                        <GridItem xs={12} sm={6} md={8}>
                            <FormControl fullWidth className={classes.formControl}>
                                <label className={errors.estabelecimento?"select__label select__label_error":"select__label"}>{t('label.establishment')} *</label>
                                <Select
                                    classNamePrefix="select"  
                                    isSearchable={true}
                                    styles={ValidSelect(errors.estabelecimento?true:false)}
                                    placeholder={t('label.select')+"..."}
                                    name="estabelecimento"
                                    isLoading={isLoadingEstabelecimento}
                                    options={estabelecimentos}
                                    value={estabelecimentos.filter(({ estabelecimentoId }) => estabelecimentoId === estabelecimento)}
                                    getOptionLabel={({ descricao }) => descricao}
                                    getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                                    onChange={(value) => handleEstabelecimentoChange(value.estabelecimentoId !== null ? value.estabelecimentoId : "")}
                                    ref={() => register( { name: "estabelecimento" }) }
                                />
                                {errors.estabelecimento &&
                                <FormHelperText>
                                    <span className="obg"> {t('label.select_an_establishment')} </span>
                                </FormHelperText>}
                            </FormControl> 
                        </GridItem>}
                        <GridItem xs={12} sm={6} md={4}>
                            <FormControl fullWidth className={classes.formControl}>
                            <label className={errors.tipopagamento ? "select__label select__label_error" : "select__label"}>{t('sale.type')} </label>
                            <Select
                                classNamePrefix="select"
                                styles={ValidSelect(errors.tipopagamento ? true : false)}
                                isSearchable={true}
                                name="tipo"
                                options={optionsTipo}
                                value={optionsTipo.filter(({value}) => value === tipo)}
                                onChange={(option) => handleTipoChange(option.value !== null ? option.value : "Todos") }
                                placeholder="Todos"
                                ref={() => register({ name: "tipo" })
                                }
                            />
                            </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={6} md={3}>
                            <FormControl fullWidth className={classes.formControl}>                                                               
                                <label className={errors.dtini?"select__label select__label_error":"select__label"}>
                                    {t('label.ini_date')+" *"}  </label>
                                <Datetime                                    
                                    locale={getLocale()}
                                    dateFormat={getStringFormatDate()}
                                    timeFormat={false}                                    
                                    name="dtini"                                      
                                    defaultValue={dtini}
                                    value={dtini}
                                    onChange={date => { setdtini(date) }}
                                    inputProps={{name:"dtini", ref:register({required: true}) , readOnly:'readonly' }}                                    
                                    className={errors.dtini?"error":""}            
                                />       
                                {errors.dtini && <FormHelperText className={classes.labelRootError}>
                                    <span> {errors.dtini.message} </span>                                                                          
                                </FormHelperText>} 
                            </FormControl>                                 
                        </GridItem>
                        <GridItem xs={12} sm={6} md={3}>
                            <FormControl fullWidth className={classes.formControl}>                                                               
                                <label className={errors.dtfim?"select__label select__label_error":"select__label"}>
                                    {t('label.end_date')+" *"}  </label>
                                <Datetime                                    
                                    locale={getLocale()}
                                    dateFormat={getStringFormatDate()}
                                    timeFormat={false}                                    
                                    name="dtfim"                                      
                                    defaultValue={dtfim}
                                    value={dtfim}
                                    onChange={date => { setdtfim(date) }}
                                    inputProps={{name:"dtfim", ref:register({required: true}) , readOnly:'readonly' }}                                    
                                    className={errors.dtfim?"error":""}            
                                />       
                                {errors.dtfim && <FormHelperText className={classes.labelRootError}>
                                    <span> {errors.dtfim.message} </span>                                                                          
                                </FormHelperText>} 
                            </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={6} md={2}>
                            <Button  round color="primary" 
                                onClick={e => { handleClickPesquisa()}}>
                                {t('label.search')} 
                            </Button>
                        </GridItem>
                        {notification.show &&
                        <div>
                            <br/>
                            <SnackbarContent
                                message={notification.message}
                                color={notification.color}
                                closeNotification={() => setNotification({show:false})}
                                close
                            />
                        </div>}
                    </GridContainer>
                    {dataCSV.length > 0 &&
                        <div>
                            <div style={{float:'right'}}>
                            <CsvDownloader
                            filename="report"
                            columns={columnsCSV}
                            datas={dataCSV}
                            separator={";"}>
                                <Button  round color="default" size="sm" >CSV</Button> 
                            </CsvDownloader>
                            </div><div style={{clear:'both'}}></div>
                        </div>
                    }
                    <ReactTable
                        loading = {isLoadingList}
                        data={list}
                        filterable
                        defaultFilterMethod = {noCaseSensitive}
                        columns={columns}
                        //defaultPageSize={10}
                        showPagination={false}
                        pageSize={list.length}
                        minRows={5}
                        showPaginationBottom={true}
                        className="-striped -highlight"
                        previousText={t('button.previous')}
                        nextText={t('button.next')}
                        loadingText={t('label.loading')+"..."}
                        noDataText={t('information_message.no_records_found')+"!"}
                        pageText={t('label.page')}
                        ofText={t('label.of')}
                        rowsText={t('label.rows')}
                    />
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
    </div>
    );
}